import { Status } from '@/utils';
import moment from 'moment';
import * as yup from 'yup';

const isTextEditorValid = (content: string) => {
  const strippedContent = content.replace(/<(.|\n)*?>/g, '').trim();
  return strippedContent.length > 0;
};

export const formSchemaFn = (isActionEdit: boolean) =>
  yup.object().shape({
    formName: yup.string().optional(),
    attachment: yup
      .string()
      .test(
        'check-images',
        'カバー画像をアップロードしてください。',
        (_, context) => {
          const image = context?.parent?.coverImage || '';
          return image !== null && image !== '';
        },
      ),
    title: yup
      .string()
      .trim()
      .required('タイトルは未入力です。')
      .max(100, 'タイトルは100文字以内で入力してください。'),
    content: yup
      .string()
      .test('is-valid-message', '本文は未入力です。', (value) =>
        isTextEditorValid(value || ''),
      )
      .url('URLは正しい形式で入力してください。')
      .required('URLが入力されていません。')
      .max(2000, '本文は2000文字以内で入力してください。'),
    status: yup
      .number()
      .required('ステータスは未入力です。')
      .oneOf([0, 1], 'ステータスは未入力です。'),
    prevStatus: yup.number().optional(),
    publicAt: yup
      .date()
      .required('公開日時を選択してください。')
      .when(['status'], ([status], schema) => {
        if (status !== Status.PUBLIC || isActionEdit) return schema;
        return schema.min(
          moment().add(1, 'minute').startOf('minute').toDate(),
          '公開日時は現在以降を選択してください。',
        );
      }),
    publicEndAt: yup
      .date()
      .nullable()
      .transform((curr, orig) => (orig === '' ? null : curr))
      .when('publicAt', ([publicAt], schema) => {
        if (!publicAt) return schema;
        return schema.min(
          moment(publicAt).startOf('minute').toDate(),
          '公開終了日時は公開日時より後にしてください。',
        );
      }),
    categoryId: yup
      .number()
      .notOneOf([null], 'カテゴリーを選択してください。')
      .required('カテゴリーを選択してください。'),
    tagNames: yup
      .array()
      .of(yup.string())
      .required('タグを選択してください。')
      .min(1, 'タグを選択してください。'),
    offerIds: yup.array().optional(),
    eventIds: yup.array().optional(),
    alwaysShowOnTimeline: yup.boolean().optional(),
    isCompanyType: yup.boolean().optional().nullable(),
  } as any);
